unable to read source [project]/momira.app/web/node_modules/src/native-bar-code-detector.ts